// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e612ba32","356":"2c9ceb0c","438":"87eecb41","465":"ba9ad547","538":"20cb8280","912":"7dcdd281","954":"5d11128a"}[chunkId] + ".chunk.js";
};